/**
 * @voltxampere/ui — AMS1117-3.3 +3.3V LDO regulator (Sprint 40-1)
 *
 * Workhorse SOT-223 LDO for 3.3 V MCU rails (ESP32, RP2040, STM32).
 * V_dropout ~ 1 V, so V_in ≥ 4.7 V is enough. I_max 1 A. Reuses the
 * dc-source SVG; canonical `voltage-source` engine type.
 *
 * Reference: AMS AMS1117-3.3 (Advanced Monolithic Systems). Engine
 * zero-diff invariant honored.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { dcSource } from "../dc-source.js";
export const regulatorAms1117_3v3 = {
    id: "ams1117-3v3",
    nameTr: "AMS1117-3.3 (+3.3V LDO, SOT-223)",
    nameEn: "AMS1117-3.3 (+3.3V LDO, SOT-223)",
    shortcut: "V",
    category: "source",
    viewBox: dcSource.viewBox,
    terminals: dcSource.terminals,
    defaultLabel: "U",
    defaultValue: "AMS1117-3.3",
    schemaType: "voltage-source",
    defaultParams: { voltage: 3.3 },
    renderSVG: () => dcSource.renderSVG(),
};
//# sourceMappingURL=regulator-ams1117-3v3.js.map